import { createFileRoute } from "@tanstack/react-router";
import UpdateOrganization from "@/features-root-user/organization/organization-detail/update-organization";

export const Route = createFileRoute(
  "/_root/root-user/organization/organization/$id/update",
)({
  component: UpdateOrganization,
});
